export default {
  CHANGE_IDENTIFYCODE: (state, payload) => {
    state.identifyCode = payload
  },
  LOGIN: (state, payload) => {
    state.user = payload
    let role = [];
    if (payload.power) {
      const power = JSON.parse(payload.power.power);
      for (let i = 0; i < power.length; i++) {
        const item = power[i];
        role = role.concat(item.checkedList)
      }
    }
    localStorage.setItem('role', JSON.stringify(role));
    localStorage.setItem('user', JSON.stringify(payload));
  },
  LOGOUT: (state) => {
    state.user = {}
    localStorage.removeItem('user')
  },
  SET_UNREAD_COUNT: (state, payload) => {
    state.unread_count = payload
  }
}


// WEBPACK FOOTER //
// ./src/vuex/mutations.js